module.exports = __webpack_public_path__ + "static/img/tsc.334f5b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tsc.jpg
// module id = tSWH
// module chunks = 1